<template>
    <div class="bank-account-owner-container">
        <div class="overview-entry">
            <label class="value">{{ fullName }}</label>
        </div>
        <div class="overview-entry">
            <label class="value">{{ displayIban }}</label>
            <label class="value">{{ displayBic }}</label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'bank-account-owner-overview',
    inject: [ 'baseData' ],
    props: {
        customer: {
            type: Object,
            required: true,
            default: () => {}
        }
    },
    computed: {
        fullName() {
            const salutation = this.baseData.salutations.find(salutation => salutation.displayid === this.customer.salutationId)
            const title = this.baseData.titles.find(title => title.displayid === this.customer.titleId)

            return `${salutation?.displayname || ''} ${title?.displayname || ''} ${this.customer.person?.firstName || ''} ${this.customer.person?.lastName || ''}`
        },
        displayIban() {
            // replace any invalid character (including spaces), then add spaces every 4 characters
            return this.customer.bankData?.iban?.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim()
        },
        displayBic() {
            return `${this.customer.bankData?.bic || ''}`
        }
    }
}
</script>

<style lang="scss" scoped>
.bank-account-owner-container {
    height: 100%;
    width: 100%;

    > .overview-entry {
        width: 100%;

        &:not(:first-child) {
            margin-top: 12px;
        }

        > label {
            display: block;
        }
        > .label {
            font-weight: bold;
        }

        > .value {
            margin-top: 4px;
            margin-left: 8px;
        }
    }
}
</style>